<template>
    <div class="action-table">
        <div class="reporting-export-button">
            <once-button
                type="tertiary"
                :text="trans('buttons.export_pdf')"
                :title="disabled_button_title_pdf"
                :spinner="disable_export_pdf"
                :additionalDisable="disable_button_pdf"
                :click="exportPdf"
            ></once-button>

            <once-button
                type="tertiary"
                :text="trans('buttons.export_excel')"
                :title="disabled_button_title_excel"
                :spinner="disable_export_excel"
                :additionalDisable="disable_button_excel"
                :click="exportExcel"
            ></once-button>

            <once-button
                type="tertiary"
                :text="trans('buttons.dl_packaged_certificates')"
                :title="disabled_button_title_cert"
                :additionalDisable="disable_button_cert"
                :click="dlPackagedCertificates"
            ></once-button>
        </div>

        <v-server-table
            :url="route('tenantapi.reporting.index')"
            :columns="columns"
            :options="options"
            ref="table"
            @loaded="handleTableUpdate"
        >
            <reporting-table-cls-column
                slot="cls_column"
                slot-scope="props"
                :data="props.row"
                :filter="filter"
            ></reporting-table-cls-column>

            <course-column
                slot="course"
                slot-scope="props"
                :data="props.row"
                :filter="filter"
            ></course-column>

            <status-column
                slot="status"
                slot-scope="props"
                :data="props.row"
                :filter="filter"
            ></status-column>

            <vue-table-loading
                slot="afterBody"
                v-if="loading"
            ></vue-table-loading>
        </v-server-table>
    </div>
</template>

<script>
import { EventBus } from '../eventbus';
import ModalDownloadPackagedCertificates from './ModalDownloadPackagedCertificates.vue';
import ModalExcelExportConfig from './ModalExcelExportConfig.vue';
import reportingTableOptions from './partials/reportingTableOptions';
import axiosDownload from '../../util/axiosDownload';
import { getDefaultFilterData } from './partials/getDefaultFilterData';
import { simplyfyFilterDataForBackend } from './partials/simplifyFilterDataForBackend';

export default {
    data() {
        return {
            loading: false,
            count: 0,
            filter: getDefaultFilterData(),
            disable_export_pdf: false,
            disable_export_excel: false,
            export_button_limit_pdf: 7500,
            export_button_limit_excel: 15000,
            export_button_limit_cert: 15000,
            columns: [
                'cls_column',
                'name',
                'client_prefixed_name',
                'course',
                'status',
                'actions',
            ],
            options: reportingTableOptions,
            query: '',
        };
    },

    computed: {
        disable_button_pdf() {
            return this.count
                ? this.count > this.export_button_limit_pdf
                : true;
        },
        disable_button_excel() {
            return this.count
                ? this.count > this.export_button_limit_excel
                : true;
        },
        disable_button_cert() {
            return this.count
                ? this.count > this.export_button_limit_cert
                : true;
        },
        disabled_button_title_pdf() {
            return this.disable_button_pdf
                ? this.trans('reporting.tooltips.disabled_export_buttons', {
                      number: this.export_button_limit_pdf,
                  })
                : '';
        },
        disabled_button_title_excel() {
            return this.disable_button_excel
                ? this.trans('reporting.tooltips.disabled_export_buttons', {
                      number: this.export_button_limit_excel,
                  })
                : '';
        },
        disabled_button_title_cert() {
            return this.disable_button_cert
                ? this.trans('reporting.tooltips.disabled_export_buttons', {
                      number: this.export_button_limit_cert,
                  })
                : '';
        },
    },

    methods: {
        handleTableUpdate({ data }) {
            this.count = data.count;
        },
        exportExcel(event) {
            var dataObject = {
                ...simplyfyFilterDataForBackend(this.filter),
                query: this.query,
            };
            if (event.ctrlKey) {
                this.$modal.show(
                    ModalExcelExportConfig,
                    {
                        dataObject: dataObject,
                    },
                    {
                        height: 'auto',
                        width: '80%',
                        adaptive: true,
                        pivotY: 0.3,
                        scrollable: true,
                    }
                );
                return;
            }
            this.callExportExcelApi(dataObject);
            return;
        },

        callExportExcelApi(dataObject) {
            this.disable_export_excel = true;
            axios({
                method: 'post',
                url: this.route('tenantapi.reporting.export.excel.index'),
                responseType: 'blob',
                data: dataObject,
            })
                .then(response => {
                    var filename = this.createExportFilename('xlsx');
                    axiosDownload(response.data, filename);
                    this.disable_export_excel = false;
                })
                .catch(error => {
                    this.flash({
                        message: this.trans('reporting.flash.error'),
                        level: 'warning',
                    });
                    this.disable_export_excel = false;
                });
        },

        exportPdf() {
            this.disable_export_pdf = true;
            axios({
                method: 'post',
                url: this.route('tenantapi.reporting.export.pdf.index'),
                responseType: 'blob',
                data: {
                    ...simplyfyFilterDataForBackend(this.filter),
                    query: this.query,
                },
            })
                .then(response => {
                    var filename = this.createExportFilename('pdf');
                    axiosDownload(response.data, filename);
                    this.disable_export_pdf = false;
                })
                .catch(error => {
                    this.flash({
                        message: this.trans('reporting.flash.error'),
                        level: 'warning',
                    });
                    this.disable_export_pdf = false;
                });
        },

        dlPackagedCertificates() {
            this.$modal.show(
                ModalDownloadPackagedCertificates,
                {
                    filter: this.filter,
                    query: this.query,
                },
                {
                    height: 'auto',
                    width: '80%',
                    adaptive: true,
                    pivotY: 0.3,
                    scrollable: true,
                }
            );
        },

        createExportFilename(type) {
            const date = new Date();
            const datestring =
                date.getFullYear() +
                '_' +
                (date.getMonth() + 1) +
                '_' +
                date.getDate();
            var clientName = '';
            if (this.filter.clients && this.filter.clients.label) {
                clientName = this.filter.clients.label + '_';
            }
            return 'SW_Reporting_' + clientName + datestring + '.' + type;
        },
    },

    mounted() {
        EventBus.$on('databaseChanged', () => {
            this.filter = getDefaultFilterData();
            this.options.sortable.pop('status');
            this.$refs.table.refresh();
        });

        EventBus.$on('filterChanged', ({ filter }) => {
            this.filter = filter;

            // Status is only sortable, when there is a course.
            // We can't sort by the status of multiple courses
            if (filter.filterByCourse) {
                this.options.sortable.push('status');
            } else {
                this.options.sortable.pop('status');
            }

            this.$refs.table.refresh();
        });

        EventBus.$on('onFilter', query => {
            this.query = query;
            this.$refs.table.setFilter(query);
        });

        EventBus.$on('excelExportConfigSet', dataObject => {
            this.callExportExcelApi(dataObject);
        });
    },
};
</script>
